









































































































































































































































































import { shipAuth, User } from "@/api/model/user";
import { getPath, LeftMenu, point, shipping } from "@/api/user";
import { getDate, strToTime } from "@/util/func";
import Vue, { PropType } from "vue";
import { AMapManager, lazyAMapApiLoaderInstance } from "vue-amap";
let amapManager = new AMapManager();
export default Vue.extend({
  data() {
    return {
      amapManager: new AMapManager(),
      // 地图中心位置
      center: <number[]>[113.740617, 22.71612],
      path: <number[][]>[],
      importPoint:<{point:number[],times:string}[]>[],
      events: <any>null,
      plugin: <any[]>[],
      showTimeRange:false,
      trackRange:{
        timeRange:[strToTime((new Date()).setDate((new Date()).getDate()-15),false),getDate(new Date(),false)]
      },
      auth:<any[]>[]
    };
  },
  props: {
    // 点列表
    leftlist: {
      type: Array as PropType<LeftMenu[]>,
      required: true,
    },
    // 选中的点
    selectIndex: {
      type: Number,
      default: -1,
    },
    // 点图标
    Icon: {
      type: Object as PropType<{ select: any; def: any }>,
      required: true,
    },
    // 显示轨迹按钮
    showTrack: {
      type: Boolean,
      default: false,
    },
    //弹框显示内容类别，0轮船信息，1仓库，2船闸
    types: {
      type: Number,
      default: 0,
    },
    //地图选点
    marker: {
      type: Object as PropType<{ lnglat: number[]; address: string }>,
    },
    isShipList: {
      type: Boolean,
      default: true,
    },
    user:{
      type: Object as PropType<User>,
      default: true,
    }
  },
  computed: {
    list: function () :any[]{
      var res = this.leftlist
      if (this.types == 0 || this.types == 4 || this.types == 5) {
        return <shipping[]>res
      }
      return res
    }
  },
  mounted() {


    // loadAmap().then(() => {
    //   console.log(this.$refs.amap);
    //   // this.$refs.amap.
    // });
    var that = this;
    console.log(this.amapManager);
    this.auth = shipAuth;
    that.$nextTick(() => {
      this.plugin = [
        {
          pName: "MapType",
          defaultType: 1, //0代表默认，1代表卫星
          showTraffic: false, // 路网
          showRoad: false, // 路况
        },
      ];
      that.events = {
        click(e: any) {
          that.$emit("clickMap", e);
          // that.stationSearch();
        },
      };
      if (that.marker && that.marker.lnglat.length == 2) {
        that.center = this.marker.lnglat;
      }
    });
  },
  methods: {
    selectPoint(index: number) {
      this.$emit("setSelect", index);
      console.log(index);
    },
    getPath() {
      getPath(this.list[this.selectIndex].uid || "",this.trackRange.timeRange[0],this.trackRange.timeRange[1])
        .then((res) => {
          res.list&&(this.path = res.list.map(v=>[v.lon/1000000,v.lat/1000000]));
          res.import_point&&(this.importPoint = res.import_point.map(v=>{return {point:[v.lon/1000000,v.lat/1000000],times:v.utc_text}}));
          // (this.$refs.info_window as HTMLFormElement).visible = false;
        })

        .finally(() => {
          
          this.showTimeRange=false
        });
    },
    clickMap(e: any) {
      console.log(e);
    },
  },
  watch: {
    selectIndex: function () {
      this.path = [];
      this.importPoint=[]
    },

  },
});
